import { IListFilterItem } from '../interfaces/list-filter.interface'


export const defaultQuickFilterItems: IListFilterItem[] = [{
  value: 'true',
  field: 'is_featured',
  label: $localize`:@@quick-filters.is_featured:Featured`,
  display: true,
},{
  value: 'true',
  field: 'filter_is_low_hours',
  label: $localize`:@@quick-filters.filter_is_low_hours:Low Hours`,
  display: true,
}, {
  value: 'true',
  field: 'has_approved_photos',
  label: $localize`:@@quick-filters.has_approved_photos:Listings with Photos`,
  display: true,
}]
